(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/helpers/data-attribute-handler.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/helpers/data-attribute-handler.js'); "use strict";

var checkIfPropertyExists = function checkIfPropertyExists(targetObject, property) {
  return Object.prototype.hasOwnProperty.call(targetObject, property);
};

var logger = svs.core.log.getLogger('components:adobe-target-payload-handler');

var getAllDataAttributes = function getAllDataAttributes(element) {
  return Object.keys(element.dataset);
};

var getDataAttributeValue = function getDataAttributeValue(element, dataAttribute) {
  if (checkIfPropertyExists(element.dataset, dataAttribute)) {
    return element.dataset[dataAttribute];
  }

  logger.warn("Missing data attribute:".concat(dataAttribute));
};

var checkIfDataAttributesExists = function checkIfDataAttributesExists(element, dataAttributes) {
  for (var i = 0; i < dataAttributes.length; i++) {
    var dataAttribute = dataAttributes[i];

    if (!checkIfPropertyExists(element.dataset, dataAttribute)) {
      return false;
    }
  }

  return true;
};

svs.components.adobeTargetPayloadHandler.helpers.getAllDataAttributes = getAllDataAttributes;
svs.components.adobeTargetPayloadHandler.helpers.checkIfDataAttributesExists = checkIfDataAttributesExists;
svs.components.adobeTargetPayloadHandler.helpers.getDataAttributeValue = getDataAttributeValue;
 })(window);